import React, { useState } from 'react';
import styled from 'styled-components';
import { useTitle } from '../../shared/hooks/useTitle';
import { paperTextureBefore } from '../../shared/component/paperTexture';
import { useArchiveNav } from '../../shared/hooks/page/useArchiveNav';
import LnbLogoUsername from './LeftLogoUsername';
import BigMenu from './BigMenu';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { useCheckBeforeMove } from '../../shared/hooks/useCheckBeforeMove';
import hamburger128 from '../../asset/gnb/hamburger_128.png';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';

export type { NavItem } from '../../shared/hooks/page/useArchiveNav';

const LeftNavBar: React.FC = () => {
  const { canShow, isVisible, isOwner, navItems } = useArchiveNav();
  const { isEditMode } = useEditMode();
  const [isHovered, setIsHovered] = useState(false);
  useTitle();
  const { getCurrentPage } = useCheckBeforeMove();
  const { page } = getCurrentPage();
  
  const isSettingsPage = page === 'settings';

  if (!canShow) return null;

  const openMenuWithHover = () => {
    if (isEditMode) return;
    setIsHovered(true);
  };

  return (
    <>
      <LnbSection
        $isHovered={isHovered}
        $isVisible={isVisible}
        onMouseLeave={() => setIsHovered(false)}
      >
        <LnbTopWrapper>
        <LnbLogoUsername isHovered={isHovered} />
        <LnbMenuContainer $isActive={isVisible}>
          {navItems.map((item) =>
            (item.isVisible || isOwner) && (
              <BigMenu
                key={item.path}
                isHovered={isHovered}
                data={item}
              />
            )
          )}
        </LnbMenuContainer>
        </LnbTopWrapper>
      </LnbSection>
      {!isHovered &&
        <>
          <LnbToggleArea
            aria-label="Open menu"
            onMouseEnter={openMenuWithHover}
            $isEditMode={isEditMode && !isSettingsPage}/>
          <HamburgerIconBtnWrapper
            aria-label="Open menu"
            onMouseEnter={openMenuWithHover}>
            <UniversalIconBtn 
                isPrimary={false}
                size="fit" 
                border={false} 
                isTransparent={true}
                backgroundImg={hamburger128} 
                onClick={() => setIsHovered(true)}/>
          </HamburgerIconBtnWrapper>
        </>
      }
    </>
  )
}

// OnBoardingLeftNavBar, AdminLeftNavBar에서 공통으로 사용하는 스타일
export const LnbSection = styled.section<{ $isHovered: boolean, $isVisible: boolean }>`
  position: absolute;
  left: 0px;
  width: ${({ $isHovered, $isVisible }) =>
    $isVisible
      ? $isHovered
        ? 'clamp(150px, 20vw, 210px)'
        : '0vw'
      : '0vw'};
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
  transition: width 0.6s ease-in-out;
  ${paperTextureBefore}
  border-top: none;
  border-left: none;
  border-bottom: none;
  z-index: 5; /* 펼쳐진 네비게이션 섹션: 토글 영역(4)보다 위, 모달(4)와는 동일/상위 레벨 */
`;

export const LnbTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const LnbMenuContainer = styled.div<{ $isActive: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  pointer-events: ${({ $isActive }) => $isActive ? 'auto' : 'none'};
  opacity: ${({ $isActive }) => $isActive ? 1 : 0};
  transition: opacity 0.4s ease;
`;

export const HamburgerIconBtnWrapper = styled.article`
  position: fixed;
  left: clamp(20px, 2vw, 30px);
  top: clamp(20px, 2vw, 30px);
  transform: scale(0.9);
  cursor: pointer;
  z-index: 4;
`;

// OnBoardingLeftNavBar, AdminLeftNavBar에서 공통으로 사용하는 스타일
export const LnbToggleArea = styled.button <{ $isEditMode: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  width: clamp(40px, 3.5vw, 100px);
  height: 5vh;
  background: transparent;
  z-index: 4; /* 네비게이션 토글 대기 영역: 일반 모달, 오버레이와 동일 레벨 */
`;
// export const LnbToggleArea = styled.button <{ $isEditMode: boolean }>`
//   position: fixed;
//   left: 0;
//   top: 0;
//   width: ${({ $isEditMode }) => $isEditMode ? 'clamp(8px, 0.8vw, 20px)' : 'clamp(40px, 3vw, 100px)'};
//   height: 100vh;
//   background: transparent;
//   z-index: 4; /* 네비게이션 토글 대기 영역: 일반 모달, 오버레이와 동일 레벨 */
// `;

export default LeftNavBar;
